import { Dialog as MuiDialog, DialogProps as MuiDialogProps } from '@mui/material';

type ModalProps = MuiDialogProps;

export const Modal = (props: ModalProps) => <MuiDialog {...props} />;
